import { Controller } from "@hotwired/stimulus"

export default class SelectNavigationController extends Controller {
  navigate(event) {
    const location = this.option_value(event.target)
    event.target.blur()

    window.Turbo.visit(location)
  }

  option_value(select) {
    return select.options[select.selectedIndex].value
  }
}
